import React from 'react'
import { TimePicker as MuiTimePicker, TimePickerProps } from '@mui/x-date-pickers'
import { makeStyles } from 'tss-react/mui'
import moment, { Moment } from '../../Libs/moment'

const useStyles = makeStyles()(theme => ({
  timePicker: {
    backgroundColor: theme.palette.background.changedInputField,
  },
}))

interface CustomTimePickerProps extends TimePickerProps<Moment, Moment> {
  highlighted?: boolean
}

const TimePicker: React.FC<CustomTimePickerProps> = ({ highlighted = false, ...otherProps }) => {
  const { classes, cx } = useStyles()

  return (
    <MuiTimePicker
      {...otherProps}
      className={cx({ [classes.timePicker]: highlighted })}
      minTime={moment().startOf('day')}
      maxTime={moment().endOf('day')}
    />
  )
}

export default TimePicker
